import { TRANSITION_END } from '../core'

$.fn.Expanding = function() {
  let self = this

  if (self.data('expanding')) {
    return self.data('expanding')
  }

  self.wrapper = $('<div class="page-wrapper" aria-expanded="false"></div>')
  self.wrapped = $(this)
  self.has_wrapped = false
  self.open_button = undefined
  self.close_button = undefined
  self.close_button_bottom = undefined
  self.max_height = 0
  self.total_height = 0

  self.initialize_wrapper = function() {
    if (!self.hasClass('expanding-end')) {
      self.nextAll('.page-section').each(function($el) {
        if (!self.has_wrapped && ($(this).hasClass('expanding-end') || $(this).is(':last-child'))) {
          self.wrapped = self.wrapped.add($(this))
          self.has_wrapped = true
        } else if (!self.has_wrapped) {
          self.wrapped = self.wrapped.add($(this))
        } else {
          return false
        }
      })
    }
    self.wrapped.wrapAll(self.wrapper)
    self.wrapper = self.wrapped.first().parent()
  }

  self.initialize_first_row = function() {
    self.wrapper.find('.row .col.order-md-2 .text-content').first().append('<p class="btn-down__wrapper text-center"><button class="btn-down">Ouvrir</button></p>');
    self.wrapper.find('.row .col.order-md-2 .text-content').first().append('<p class="btn-up__wrapper text-center"><button class="btn-up">Fermer</button></p>');
    $(window).on('load resize orientationchange', self.resize_first_row)
    self.resize_first_row()
    self.open_button = self.find('.btn-down').on('click', self.open)
    self.close_button = self.find('.btn-up').on('click', self.close)
    self.close_button_bottom = self.close_button.clone().on('click', self.close)
    self.wrapper.find('.page-section').last().append(self.close_button_bottom)
  }

  self.resize_first_row = function() {
    self.max_height = parseFloat(self.wrapper.find('.page-section').first().css('padding-top'))
    self.max_height += parseFloat(self.wrapper.find('.page-section .row').first().outerHeight(true))
    self.max_height = Math.ceil(self.max_height) + 1

    if (self.wrapper.attr('aria-expanded') === 'false') {
      /* total height */
      self.wrapper.css('height', '')
      self.total_height = self.wrapper.outerHeight(false)

      /* max height */
      self.wrapper.css('height', self.max_height + 'px')
    }
  }

  self.open = function() {
    if (self.wrapper.hasClass('animated')) {
      return
    }
    self.wrapper.css('height', self.wrapper.outerHeight(false) + 'px').addClass('animated')
    requestAnimationFrame(function() {
      self.wrapper.css('height', self.total_height + 'px').off(TRANSITION_END).one(TRANSITION_END, function() {
        self.wrapper.attr('aria-expanded', 'true')
        self.wrapper.off(TRANSITION_END)
        self.wrapper.css('height', '')
        self.wrapper.removeClass('animated')
      })
    })
  }

  self.close = function() {
    if (self.wrapper.hasClass('animated')) {
      return
    }
    clearTimeout(self.scroll_timeout)
    self.wrapper.css('height', self.wrapper.outerHeight(false) + 'px').addClass('animated')
    let willScroll = 60
    if (self.wrapper.offset().top < $.mlmi.scroller.scrollTop()) {
      let targetTop = self.wrapper.offset().top
      targetTop -= $('.header').first().height()
      targetTop -= parseFloat(self.wrapper.css('marginTop')) / 2
      $('html, body').scrollTo(Math.ceil(targetTop), 450, 10000, 'easeInOutQuart')
      willScroll = 550
    }
    self.scroll_timeout = setTimeout(function() {
      self.wrapper.css('height', self.max_height + 'px').off(TRANSITION_END).one(TRANSITION_END, function() {
        self.wrapper.attr('aria-expanded', 'false')
        self.wrapper.removeClass('animated')
        self.wrapper.off(TRANSITION_END)
        self.resize_first_row()
      })
    }, willScroll)
  }

  return function() {
    self.initialize_wrapper()
    self.initialize_first_row()
    self.data('expanding', self)
    return self
  }()
}
